var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.overlay = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }